import Marquee from "react-fast-marquee";

const items = [
  "100% Natural",
  "No Artificial Colours",
  "Belgian Chocolate",
  "Real Fruit",
  "Small Batch",
  "Made in Bengaluru",
];

export default function MarqueeStrip() {
  return (
    <section className="bg-cocoa text-vanilla py-6 overflow-hidden" data-testid="marquee-section">
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-heading font-500 text-2xl sm:text-3xl px-8 tracking-tight">
              {t}
            </span>
            <span className="text-pistachio text-2xl">✳</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
